module.exports = __webpack_public_path__ + "static/media/client-app-annie.483a4616.png";